import { Box, Button, useTheme } from "@mui/material";
import { FC } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useLocalization } from "../../hooks/useLocalization";

interface MinSessionDurationTriggerProps {
  label: string;
  value: number | null;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const MinSessionDurationTrigger: FC<MinSessionDurationTriggerProps> = ({
  label,
  value,
  onClick,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();
  const isMobile = useIsMobile();

  const secondaryText =
    value === null
      ? `(${t("components.minSessionDurationFilter.any")})`
      : `(${value})`;

  if (isMobile) {
    return (
      <Button
        onClick={onClick}
        sx={{
          fontWeight: 600,
          fontSize: 14,
          color: theme.colors.text[5],
          textDecoration: "underline",
          px: 0,
        }}
      >
        {`${label} ${secondaryText}`}
      </Button>
    );
  }

  return (
    <Button
      onClick={onClick}
      size="small"
      sx={{
        backgroundColor: "transparent",
        borderRadius: "16px",
        color: value === null ? theme.colors.text[3] : theme.colors.text[6],
        fontSize: 12,
        fontWeight: 500,
        height: 32,
        width: "fit-content",
        "&:hover": {
          backgroundColor: theme.colors.secondary[0],
          textDecoration: "underline",
        },
      }}
      variant="contained"
    >
      {label}
      <Box
        sx={{
          textAlign: "left",
          ml: 0.5,
        }}
      >
        {secondaryText}
      </Box>
    </Button>
  );
};
